<app-main-header [name_main]="pageTitle" [goBack]="true">
  <button class="button-header" mat-flat-button color="primary" [disabled]="isSaving || isLoading" (click)="saveSchema()">
    {{ isEditMode ? 'ACTUALIZAR' : 'GUARDAR' }}
  </button>
  @if (isEditMode) {
    <button class="button-header" mat-flat-button color="warn" (click)="deleteSchema()">ELIMINAR</button>
  }
</app-main-header>

<section class="schemas-editor-page">
  @if (isLoading) {
    <div class="status-box">Cargando modelo de datos...</div>
  } @else {
    <form [formGroup]="form" class="schema-form">
      <mat-accordion class="schema-accordion" multi>
        <mat-expansion-panel class="editor-card schema-panel" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Información general</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="general-info">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="name" placeholder="nombre del esquema" (input)="onNameInput()">
              <mat-error *ngIf="form.get('name')?.hasError('required')">El nombre es obligatorio.</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <input matInput formControlName="description" placeholder="¿para qué se usa este esquema? (opcional)">
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Tabla destino</mat-label>
              <input
                matInput
                formControlName="target_table"
                placeholder="nombre_tabla_destino"
                (input)="onTargetTableInput()">
              <mat-hint>Se sugiere desde el nombre del modelo, pero puedes editarlo.</mat-hint>
              <mat-error *ngIf="form.get('target_table')?.hasError('required')">El nombre de la tabla es obligatorio.</mat-error>
            </mat-form-field>
          </div>

          <button
            mat-button
            type="button"
            class="advanced-toggle"
            (click)="showDestinationAdvanced = !showDestinationAdvanced">
            <mat-icon>{{ showDestinationAdvanced ? 'expand_less' : 'settings' }}</mat-icon>
            {{ showDestinationAdvanced ? 'Ocultar configuración avanzada' : 'Configuración avanzada (opcional)' }}
          </button>

          @if (showDestinationAdvanced) {
            <div class="general-info destination-advanced">
              <p class="advanced-hint">Motor y esquema de base de datos. Editalos solo si sabés lo que hacés.</p>
              <mat-form-field appearance="outline">
                <mat-label>Motor de base de datos</mat-label>
                <mat-select formControlName="destination_type">
                  <mat-option value="postgres">postgres</mat-option>
                  <mat-option value="bigquery">bigquery</mat-option>
                  <mat-option value="mysql">mysql</mat-option>
                  <mat-option value="snowflake">snowflake</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Esquema destino (BD)</mat-label>
                <input matInput formControlName="target_schema" placeholder="public">
                <mat-hint>En Postgres suele ser "public"</mat-hint>
              </mat-form-field>
            </div>
          }
        </mat-expansion-panel>

        <mat-expansion-panel class="editor-card schema-panel" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Columnas</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="section-header">
            <div class="section-actions">
              <input #sampleFileInput type="file" accept=".csv,.xlsx" hidden (change)="onSampleFileSelected($event)">
              <button
                mat-flat-button
                color="primary"
                type="button"
                (click)="sampleFileInput.click()"
                matTooltip="Carga un CSV o XLSX y crea las columnas automáticamente usando la primera fila del archivo.">
                <mat-icon>upload_file</mat-icon>
                Cargar desde archivo
              </button>
              <button
                mat-stroked-button
                type="button"
                (click)="addColumn()"
                matTooltip="Agrega una nueva columna manualmente para definir su nombre, tipo y validaciones.">
                <mat-icon>add</mat-icon>
                Añadir columna
              </button>
              <!-- <button mat-stroked-button type="button" (click)="openColumnsJsonDialog()">Crear con JSON</button> -->
            </div>
          </div>
          <p class="section-hint">Puedes cargar las columnas desde un archivo o agregarlas manualmente. Selecciona una para editar su detalle.</p>

          <div formArrayName="columns" class="columns-slider">
            <div class="column-tabs">
              @for (columnGroup of columnsArray.controls; track columnGroup; let i = $index) {
                <button
                  type="button"
                  class="column-tab"
                  [class.active]="i === selectedColumnIndex"
                  [class.has-error]="formSubmitted && columnGroup.invalid"
                  (click)="selectColumn(i)">
                  <mat-icon>{{ columnTypeIcon(i) }}</mat-icon>
                  <span>{{ columnGroup.get('label')?.value || ('Columna ' + (i + 1)) }}</span>
                  @if (formSubmitted && columnGroup.invalid) {
                    <span class="tab-error-dot"></span>
                  }
                </button>
              }
              <button type="button" class="column-tab column-tab-add" (click)="addColumn()">
                <mat-icon>add</mat-icon>
              </button>
            </div>

            @for (columnGroup of columnsArray.controls; track columnGroup; let i = $index) {
              @if (i === selectedColumnIndex) {
                <div class="column-block" [formGroupName]="i">
                  <div class="column-head">
                    <button mat-icon-button type="button" (click)="prevColumn()" [disabled]="selectedColumnIndex === 0">
                      <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span class="column-title">Columna {{ i + 1 }} de {{ columnsArray.length }}</span>
                    <button mat-icon-button type="button" (click)="nextColumn()" [disabled]="selectedColumnIndex === columnsArray.length - 1">
                      <mat-icon>chevron_right</mat-icon>
                    </button>
                    <span class="column-head-spacer"></span>
                    <div class="column-head-actions">
                      <mat-checkbox formControlName="required">Requerido</mat-checkbox>
                      <mat-checkbox formControlName="unique">Único</mat-checkbox>
                      <button mat-icon-button color="warn" type="button" (click)="removeColumn(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>

                  <div class="column-fields">
                    <mat-form-field appearance="outline">
                      <mat-label>Etiqueta en archivo</mat-label>
                      <input matInput formControlName="label" placeholder="nombre visible en CSV/Excel">
                      <mat-error *ngIf="columnGroup.get('label')?.hasError('required')">La etiqueta es obligatoria.</mat-error>
                      <mat-error *ngIf="columnGroup.get('label')?.hasError('duplicateLabel')">Ya hay otra columna con esta etiqueta.</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Nombre de columna en tabla</mat-label>
                      <input
                        matInput
                        formControlName="name"
                        placeholder="nombre_columna_destino"
                        (input)="onColumnNameInput(i)">
                      <mat-hint>Se sugiere desde la etiqueta, pero puedes editarlo.</mat-hint>
                      <mat-error *ngIf="columnGroup.get('name')?.hasError('required')">El nombre de la columna en la tabla es obligatorio.</mat-error>
                      <mat-error *ngIf="columnGroup.get('name')?.hasError('pattern')">Usa minúsculas, números y guion bajo; debe iniciar con una letra.</mat-error>
                      <mat-error *ngIf="columnGroup.get('name')?.hasError('duplicateName')">Ya existe otra columna con este nombre.</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Tipo de dato</mat-label>
                      <mat-select formControlName="data_type">
                        @for (option of dataTypeOptions; track option.value) {
                          <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                      </mat-select>
                      <mat-hint>{{ dataTypeHint(i) }}</mat-hint>
                    </mat-form-field>
                  </div>

                  <button
                    mat-button
                    type="button"
                    class="constraints-toggle"
                    [class.is-open]="isConstraintExpanded(i)"
                    (click)="toggleConstraints(i)">
                    <mat-icon>tune</mat-icon>
                    Más opciones
                    <mat-icon class="toggle-arrow">{{ isConstraintExpanded(i) ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>

                  @if (isConstraintExpanded(i)) {
                    <div class="constraints-panel">
                      @if (isTextColumn(i)) {
                        <div class="column-fields">
                          <mat-form-field appearance="outline">
                            <mat-label>Longitud máxima</mat-label>
                            <input matInput type="number" formControlName="max_length" placeholder="ej: 255">
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Valores permitidos</mat-label>
                            <input matInput formControlName="enum_values" placeholder="activo, inactivo, pendiente">
                            <mat-hint>Separados por coma</mat-hint>
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Patrón regex</mat-label>
                            <input matInput formControlName="regex" placeholder="^[A-Z]{2}[0-9]{4}$">
                          </mat-form-field>
                        </div>
                      }

                      @if (isNumericColumn(i)) {
                        <div class="column-fields">
                          <mat-form-field appearance="outline">
                            <mat-label>Valor mínimo</mat-label>
                            <input matInput type="number" formControlName="min_value">
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Valor máximo</mat-label>
                            <input matInput type="number" formControlName="max_value">
                            <mat-error *ngIf="columnGroup.get('max_value')?.hasError('rangeInvalid')">Debe ser mayor o igual al valor mínimo.</mat-error>
                          </mat-form-field>
                          @if (isDecimalColumn(i)) {
                            <mat-form-field appearance="outline">
                              <mat-label>Precisión total</mat-label>
                              <input matInput type="number" formControlName="precision" placeholder="ej: 10">
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                              <mat-label>Decimales (escala)</mat-label>
                              <input matInput type="number" formControlName="scale" placeholder="ej: 2">
                            </mat-form-field>
                          }
                        </div>
                      }

                      @if (isDateColumn(i)) {
                        <div class="column-fields">
                          <mat-form-field appearance="outline">
                            <mat-label>Formato fecha</mat-label>
                            <input matInput formControlName="date_format" placeholder="ej: %Y-%m-%d">
                          </mat-form-field>
                        </div>
                      }

                      <div class="column-fields column-meta-fields">
                        <mat-form-field appearance="outline">
                          <mat-label>Valor por defecto</mat-label>
                          <input matInput formControlName="default_value" placeholder="opcional">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label>Descripción</mat-label>
                          <input matInput formControlName="description" placeholder="qué representa esta columna">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label>Ejemplo</mat-label>
                          <input matInput formControlName="example" placeholder="valor de ejemplo para la plantilla">
                        </mat-form-field>
                      </div>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="editor-card schema-panel" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>Agregar Permisos</mat-panel-title>
          </mat-expansion-panel-header>

          <p class="section-hint">Vos ya tenés acceso automáticamente como creador. Agregá acá a otras personas que también deban usar este modelo.</p>

          <div class="permissions-add-row">
            <app-search-autocomplete
              class="user-search"
              [title]="'Buscar por correo electrónico'"
              [placeholder]="'Escribe el correo del usuario'"
              [items]="usersSearchItems"
              [disableStyle]="true"
              (itemSelected)="onUserSelected($event)">
            </app-search-autocomplete>
          </div>

          @if (permissions.length) {
            <div class="permissions-list">
              @for (permission of permissions; track permission.uid) {
                <div class="permission-item">
                  <div class="permission-user">
                    <strong>{{ permission.label }}</strong>
                    <span>{{ permission.uid }}</span>
                  </div>
                  <div class="permission-actions">
                    <button mat-icon-button color="warn" type="button" (click)="removePermissionUser(permission.uid)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          } @else {
            <p class="empty-text">Aún no hay usuarios agregados.</p>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </form>
  }
</section>
